var React = require('react');

function Sandbox (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"26.5","cy":"26.5","r":"26.5","fill":"#001B66","key":0}),React.createElement("rect",{"x":"22.4375","y":"15.4785","width":"14.4325","height":"14.4325","fill":"#A803FC","key":1}),React.createElement("path",{"d":"M33.0508 35.8606L39.2091 29.7023L33.0508 23.5439","stroke":"white","strokeWidth":"1.24435","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M18.8341 23.5439L12.6758 29.7023L18.8341 35.8606","stroke":"white","strokeWidth":"1.24435","strokeLinecap":"round","strokeLinejoin":"round","key":3}),React.createElement("path",{"d":"M20.7422 39.6743L31.3543 20.1479","stroke":"white","strokeWidth":"1.24435","strokeLinecap":"round","strokeLinejoin":"round","key":4})]);
}

Sandbox.defaultProps = {"width":"53","height":"53","viewBox":"0 0 53 53","fill":"none"};

module.exports = Sandbox;

Sandbox.default = Sandbox;
